import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      // Header
      'nav.discover': 'Discover',
      'nav.insights': 'Insights',
      'nav.reviews': 'Reviews',
      'nav.signIn': 'Sign In',
      'nav.listProperty': 'List Your Property',
      'nav.myTrips': 'My Trips',
      'nav.extranet': 'Hotel Admin',
      'nav.adminConsole': 'Admin Console',
      'nav.logout': 'Logout',

      // Hero
      'hero.title': 'Real prices. Real properties. Real cashbacks',
      'hero.subtitle': 'Earn <strong>cashback</strong> when you book, review & refer. Redeem it on your next trip.',
      'hero.where': 'Where',
      'hero.whereLabel': 'You are staying to?',
      'hero.checkIn': 'Check-in',
      'hero.checkOut': 'Check-out',
      'hero.guests': 'Guests',
      'hero.search': 'Search',

      // Sections
      'section.trending': 'Trending in North India',
      'section.trendingSubtitle': 'Where Indian travellers are going right now',
      'section.seeAll': 'See all destinations',
      'section.propertyTypes': 'Browse by property type',
      'section.propertyTypesSubtitle': 'From royal palaces to budget stays — we have it all',
      'section.topHotels': 'Top hotels this month',
      'section.topHotelsSubtitle': 'Ranked by guest ratings & verified bookings',
      'section.editorsChoice': "EDITORS' CHOICE",
      'section.allHotels': 'All North India stays',
      'section.staysIn': 'Stays in {{city}}',
      'section.properties': '{{count}} properties',
      'section.insights': 'Travel guides & city stories',
      'section.insightsSubtitle': 'Curated by Punjab & Haryana locals — for travellers who go deeper',
      'section.testimonials': 'Loved by 25,000+ travellers',
      'section.testimonialsSubtitle': 'Real stories from real stays across North India',
      'section.testimonialsTag': 'WHAT TRAVELLERS SAY',
      'section.insightsTag': 'INSIGHTS',
      'section.ownHotel': 'Own a hotel in North India?',
      'section.ownHotelSubtitle': 'List your property on localliink.com for free. Reach 25,000+ travellers across Punjab, Haryana & Chandigarh.',
      'section.listPropertyCta': 'List your property →',
      'common.startingFrom': 'Starting from',
      'common.perNight': 'per night',
      'common.payAtHotel': 'pay at hotel',
      'common.readArticle': 'Read article',
      'common.trending': 'TRENDING',
      'common.featured': '⭐ Featured',
      'common.morePhotos': '+{{count}} Photos',
      'common.reviews': '{{count}} reviews',
      'common.noHotels': 'No hotels match your filters. Try removing some.',
      'common.share': 'Share',

      // Booking widget
      'booking.title': 'Reserve your stay',
      'booking.room': 'Room',
      'booking.guestsLabel': 'Guests',
      'booking.guestDetails': 'Guest details',
      'booking.fullName': 'Full name',
      'booking.email': 'Email',
      'booking.phone': 'Phone (+91...)',
      'booking.haveGuestCode': 'Have a Guest Code?',
      'booking.apply': 'Apply',
      'booking.walletDiscount': 'Wallet discount',
      'booking.payAtHotel': 'Pay at hotel',
      'booking.cta': 'Reserve · Pay at Hotel',
      'booking.ctaLoading': 'Booking...',
      'booking.noCharge': "You won't be charged yet — pay on arrival",
      'booking.freeCancellation': 'Pay at hotel · Free cancellation',
      'booking.about': 'About this stay',
      'booking.amenities': 'Amenities',
      'booking.chooseRoom': 'Choose your room',
      'booking.aroundProperty': 'Around the property',
      'booking.reviews': 'Guest reviews ({{count}})',
      'booking.filterReviews': 'Filter reviews',
      'booking.hideFilters': 'Hide filters',
      'booking.allRatings': 'All ratings',
      'booking.replyFrom': 'Reply from {{hotel}}',
      'booking.upToGuests': 'Up to {{n}} guests',
      'booking.bookingId': 'Booking ID',
      'booking.checkIn': 'Check-in',
      'booking.checkOut': 'Check-out',
      'booking.payment': 'Payment',
      'booking.downloadVoucher': 'Download Voucher',
      'booking.rateHotel': 'Rate Hotel',
      'booking.youRated': 'You rated this hotel',
      'booking.cancelBooking': 'Cancel Booking',

      // Amenities chips
      'amenity.wifi': 'Free WiFi',
      'amenity.breakfast': 'Free Breakfast',
      'amenity.parking': 'Free Parking',
      'amenity.pool': 'Pool',
      'amenity.gym': 'Gym',
      'amenity.spa': 'Spa',

      // Auth
      'auth.welcomeBack': 'Welcome back',
      'auth.signInSubtitle': 'Sign in to continue your journey',
      'auth.emailOrPhone': 'Email or phone',
      'auth.password': 'Password',
      'auth.signIn': 'Sign in',
      'auth.noAccount': "Don't have an account?",
      'auth.createAccount': 'Create account',
      'auth.signUp': 'Sign up',
      'auth.fullName': 'Full name',
      'auth.email': 'Email',
      'auth.phone': 'Phone',
      'auth.iAmA': 'I am a',
      'auth.roleGuest': 'Guest',
      'auth.roleHotel': 'Hotel owner',
      'auth.alreadyHaveAccount': 'Already have an account?',
      'auth.sendOtp': 'Send OTP',
      'auth.verifyOtp': 'Verify OTP',
      'auth.signingIn': 'Signing in...',
      'auth.creating': 'Creating...',

      // My Bookings
      'mybookings.title': 'My Trips',
      'mybookings.subtitle': 'All your reservations in one place',
      'mybookings.empty': 'No bookings yet — start exploring!',
      'mybookings.exploreCta': 'Discover hotels',
      'mybookings.status.pending': 'Pending',
      'mybookings.status.confirmed': 'Confirmed',
      'mybookings.status.checked_in': 'Checked in',
      'mybookings.status.checked_out': 'Checked out',
      'mybookings.status.cancelled': 'Cancelled',

      // Profile
      'profile.title': 'My Profile',
      'profile.guestCode': 'My Guest Code',
      'profile.guestCodeHint': 'Share this code at check-out to earn 5% cashback',
      'profile.walletBalance': 'Wallet balance',
      'profile.walletExpiry': 'expires in 30 days',
      'profile.recentActivity': 'Recent wallet activity',
      'profile.noActivity': 'No wallet activity yet',
      'profile.copyCode': 'Copy code',
      'profile.codeCopied': 'Guest code copied',

      // Shop
      'shop.title': 'LocalShop',
      'shop.subtitle': 'Pay 100% with your Liink Wallet credits. Curated travel essentials and authentic Punjabi goods.',
      'shop.allCategories': 'All',
      'shop.addToCart': 'Add to cart',
      'shop.cart': 'Cart',
      'shop.cartEmpty': 'Your cart is empty',
      'shop.checkout': 'Pay {{amount}} from wallet',
      'shop.orderPlaced': 'Order placed!',
      'shop.outOfStock': 'Out of stock',
      'shop.inStock': '{{n}} in stock',
      'shop.walletOnly': 'Wallet-only checkout',
      'shop.deliveryName': 'Full name for delivery',
      'shop.deliveryPhone': 'Phone',
      'shop.deliveryAddress': 'Address',

      // List Your Property
      'partner.heroBadge': 'JOIN 32+ HOTELS ACROSS NORTH INDIA',
      'partner.heroTitle': 'List your property on',
      'partner.heroSubtitle': 'Reach lakhs of travellers booking stays in Punjab, Haryana and Chandigarh. Free to list. Pay only when a guest actually checks in.',
      'partner.startListing': "Start listing — it's free",
      'partner.howItWorks': 'How it works',
      'partner.formTitle': 'Get started in 60 seconds',
      'partner.formSubtitle': 'No payment. No long forms. Just a quick intro.',
      'partner.propertyName': 'Property name',
      'partner.city': 'City',
      'partner.email': 'Email',
      'partner.phoneOptional': 'Phone (optional)',
      'partner.continue': 'Continue',
      'partner.faqs': 'FAQs',

      // Misc
      'lang.label': 'Language',
    },
  },
  hi: {
    translation: {
      'nav.discover': 'खोजें',
      'nav.insights': 'विशेष',
      'nav.reviews': 'समीक्षाएं',
      'nav.signIn': 'साइन इन',
      'nav.listProperty': 'अपनी संपत्ति लिस्ट करें',
      'nav.myTrips': 'मेरी यात्राएं',
      'nav.extranet': 'होटल एडमिन',
      'nav.adminConsole': 'एडमिन कंसोल',
      'nav.logout': 'लॉगआउट',

      'hero.title': 'असली कीमतें। असली प्रॉपर्टीज़। असली कैशबैक।',
      'hero.subtitle': 'बुक करें, समीक्षा करें और रेफर करें — <strong>कैशबैक</strong> कमाएं। अगली यात्रा पर रिडीम करें।',
      'hero.where': 'कहाँ',
      'hero.whereLabel': 'आप कहाँ ठहर रहे हैं?',
      'hero.checkIn': 'चेक-इन',
      'hero.checkOut': 'चेक-आउट',
      'hero.guests': 'मेहमान',
      'hero.search': 'खोजें',

      'section.trending': 'उत्तर भारत में ट्रेंडिंग',
      'section.trendingSubtitle': 'जहाँ भारतीय यात्री अभी जा रहे हैं',
      'section.seeAll': 'सभी गंतव्य देखें',
      'section.propertyTypes': 'संपत्ति प्रकार के अनुसार ब्राउज़ करें',
      'section.propertyTypesSubtitle': 'शाही महलों से बजट स्टे तक — हमारे पास सब है',
      'section.topHotels': 'इस महीने के टॉप होटल',
      'section.topHotelsSubtitle': 'अतिथि रेटिंग और सत्यापित बुकिंग के अनुसार',
      'section.editorsChoice': 'संपादक की पसंद',
      'section.allHotels': 'सभी उत्तर भारत स्टे',
      'section.staysIn': '{{city}} में स्टे',
      'section.properties': '{{count}} प्रॉपर्टीज़',
      'section.insights': 'यात्रा गाइड और शहर की कहानियां',
      'section.insightsSubtitle': 'पंजाब और हरियाणा के स्थानीय लोगों द्वारा क्यूरेट — गहराई में जाने वाले यात्रियों के लिए',
      'section.testimonials': '25,000+ यात्रियों द्वारा पसंद किया गया',
      'section.testimonialsSubtitle': 'उत्तर भारत में असली ठहराव की असली कहानियां',
      'section.testimonialsTag': 'यात्री क्या कहते हैं',
      'section.insightsTag': 'विशेष',
      'section.ownHotel': 'उत्तर भारत में होटल है?',
      'section.ownHotelSubtitle': 'localliink.com पर अपनी संपत्ति मुफ्त में लिस्ट करें। 25,000+ यात्रियों तक पहुंचें।',
      'section.listPropertyCta': 'अपनी संपत्ति लिस्ट करें →',
      'common.startingFrom': 'शुरुआत',
      'common.perNight': 'प्रति रात',
      'common.payAtHotel': 'होटल पर भुगतान',
      'common.readArticle': 'लेख पढ़ें',
      'common.trending': 'ट्रेंडिंग',
      'common.featured': '⭐ फीचर्ड',
      'common.morePhotos': '+{{count}} फोटो',
      'common.reviews': '{{count}} समीक्षाएं',
      'common.noHotels': 'आपके फिल्टर से मेल नहीं खाता। कुछ हटाने का प्रयास करें।',
      'common.share': 'शेयर',

      'booking.title': 'अपना ठहराव बुक करें',
      'booking.room': 'कमरा',
      'booking.guestsLabel': 'मेहमान',
      'booking.guestDetails': 'अतिथि विवरण',
      'booking.fullName': 'पूरा नाम',
      'booking.email': 'ईमेल',
      'booking.phone': 'फोन (+91...)',
      'booking.haveGuestCode': 'गेस्ट कोड है?',
      'booking.apply': 'लागू करें',
      'booking.walletDiscount': 'वॉलेट डिस्काउंट',
      'booking.payAtHotel': 'होटल पर भुगतान',
      'booking.cta': 'रिज़र्व · होटल पर भुगतान',
      'booking.ctaLoading': 'बुकिंग...',
      'booking.noCharge': 'अभी कोई चार्ज नहीं — पहुंचने पर भुगतान करें',
      'booking.freeCancellation': 'होटल पर भुगतान · मुफ्त रद्दीकरण',
      'booking.about': 'इस ठहराव के बारे में',
      'booking.amenities': 'सुविधाएं',
      'booking.chooseRoom': 'अपना कमरा चुनें',
      'booking.aroundProperty': 'आसपास',
      'booking.reviews': 'अतिथि समीक्षाएं ({{count}})',
      'booking.filterReviews': 'समीक्षाएं फिल्टर करें',
      'booking.hideFilters': 'फिल्टर छिपाएं',
      'booking.allRatings': 'सभी रेटिंग',
      'booking.replyFrom': '{{hotel}} का जवाब',
      'booking.upToGuests': 'अधिकतम {{n}} मेहमान',
      'booking.bookingId': 'बुकिंग ID',
      'booking.checkIn': 'चेक-इन',
      'booking.checkOut': 'चेक-आउट',
      'booking.payment': 'भुगतान',
      'booking.downloadVoucher': 'वाउचर डाउनलोड करें',
      'booking.rateHotel': 'होटल रेट करें',
      'booking.youRated': 'आपने इस होटल को रेट किया',
      'booking.cancelBooking': 'बुकिंग रद्द करें',

      'amenity.wifi': 'मुफ्त वाईफाई',
      'amenity.breakfast': 'मुफ्त नाश्ता',
      'amenity.parking': 'मुफ्त पार्किंग',
      'amenity.pool': 'पूल',
      'amenity.gym': 'जिम',
      'amenity.spa': 'स्पा',

      // Auth
      'auth.welcomeBack': 'वापसी पर स्वागत है',
      'auth.signInSubtitle': 'अपनी यात्रा जारी रखने के लिए साइन इन करें',
      'auth.emailOrPhone': 'ईमेल या फ़ोन',
      'auth.password': 'पासवर्ड',
      'auth.signIn': 'साइन इन',
      'auth.noAccount': 'खाता नहीं है?',
      'auth.createAccount': 'खाता बनाएं',
      'auth.signUp': 'साइन अप',
      'auth.fullName': 'पूरा नाम',
      'auth.email': 'ईमेल',
      'auth.phone': 'फ़ोन',
      'auth.iAmA': 'मैं हूं',
      'auth.roleGuest': 'मेहमान',
      'auth.roleHotel': 'होटल मालिक',
      'auth.alreadyHaveAccount': 'पहले से खाता है?',
      'auth.sendOtp': 'OTP भेजें',
      'auth.verifyOtp': 'OTP सत्यापित करें',
      'auth.signingIn': 'साइन इन हो रहा है...',
      'auth.creating': 'बनाया जा रहा है...',

      // My Bookings
      'mybookings.title': 'मेरी यात्राएं',
      'mybookings.subtitle': 'आपकी सभी बुकिंग एक जगह',
      'mybookings.empty': 'अभी तक कोई बुकिंग नहीं — खोजें!',
      'mybookings.exploreCta': 'होटल खोजें',
      'mybookings.status.pending': 'लंबित',
      'mybookings.status.confirmed': 'पुष्टि',
      'mybookings.status.checked_in': 'चेक-इन हो गया',
      'mybookings.status.checked_out': 'चेक-आउट हो गया',
      'mybookings.status.cancelled': 'रद्द',

      // Profile
      'profile.title': 'मेरी प्रोफ़ाइल',
      'profile.guestCode': 'मेरा गेस्ट कोड',
      'profile.guestCodeHint': '5% कैशबैक पाने के लिए चेक-आउट पर यह कोड साझा करें',
      'profile.walletBalance': 'वॉलेट बैलेंस',
      'profile.walletExpiry': '30 दिनों में समाप्त होगा',
      'profile.recentActivity': 'हाल की वॉलेट गतिविधि',
      'profile.noActivity': 'अभी तक कोई वॉलेट गतिविधि नहीं',
      'profile.copyCode': 'कोड कॉपी करें',
      'profile.codeCopied': 'गेस्ट कोड कॉपी हो गया',

      // Shop
      'shop.title': 'लोकलशॉप',
      'shop.subtitle': 'अपने Liink वॉलेट क्रेडिट से 100% भुगतान करें। चुनिंदा यात्रा आवश्यकताएं और प्रामाणिक पंजाबी सामान।',
      'shop.allCategories': 'सभी',
      'shop.addToCart': 'कार्ट में जोड़ें',
      'shop.cart': 'कार्ट',
      'shop.cartEmpty': 'आपका कार्ट खाली है',
      'shop.checkout': 'वॉलेट से {{amount}} का भुगतान करें',
      'shop.orderPlaced': 'ऑर्डर दिया गया!',
      'shop.outOfStock': 'स्टॉक में नहीं',
      'shop.inStock': '{{n}} स्टॉक में',
      'shop.walletOnly': 'केवल वॉलेट से भुगतान',
      'shop.deliveryName': 'डिलीवरी के लिए पूरा नाम',
      'shop.deliveryPhone': 'फ़ोन',
      'shop.deliveryAddress': 'पता',

      // Partner
      'partner.heroBadge': 'उत्तर भारत के 32+ होटलों से जुड़ें',
      'partner.heroTitle': 'अपनी संपत्ति यहां लिस्ट करें',
      'partner.heroSubtitle': 'पंजाब, हरियाणा और चंडीगढ़ में लाखों यात्रियों तक पहुंचें। लिस्ट करना मुफ़्त। मेहमान के चेक-इन पर ही भुगतान।',
      'partner.startListing': 'लिस्टिंग शुरू करें — मुफ़्त है',
      'partner.howItWorks': 'यह कैसे काम करता है',
      'partner.formTitle': '60 सेकंड में शुरू करें',
      'partner.formSubtitle': 'कोई भुगतान नहीं। कोई लंबा फॉर्म नहीं। बस एक त्वरित परिचय।',
      'partner.propertyName': 'संपत्ति का नाम',
      'partner.city': 'शहर',
      'partner.email': 'ईमेल',
      'partner.phoneOptional': 'फ़ोन (वैकल्पिक)',
      'partner.continue': 'जारी रखें',
      'partner.faqs': 'अक्सर पूछे जाने वाले प्रश्न',

      'lang.label': 'भाषा',
    },
  },
  pa: {
    translation: {
      'nav.discover': 'ਖੋਜੋ',
      'nav.insights': 'ਖਾਸ',
      'nav.reviews': 'ਸਮੀਖਿਆਵਾਂ',
      'nav.signIn': 'ਸਾਈਨ ਇਨ',
      'nav.listProperty': 'ਆਪਣੀ ਜਾਇਦਾਦ ਸੂਚੀਬੱਧ ਕਰੋ',
      'nav.myTrips': 'ਮੇਰੀਆਂ ਯਾਤਰਾਵਾਂ',
      'nav.extranet': 'ਹੋਟਲ ਐਡਮਿਨ',
      'nav.adminConsole': 'ਐਡਮਿਨ ਕੰਸੋਲ',
      'nav.logout': 'ਲੌਗ ਆਉਟ',

      'hero.title': 'ਅਸਲੀ ਕੀਮਤਾਂ। ਅਸਲੀ ਜਾਇਦਾਦਾਂ। ਅਸਲੀ ਕੈਸ਼ਬੈਕ।',
      'hero.subtitle': 'ਬੁੱਕ ਕਰੋ, ਸਮੀਖਿਆ ਕਰੋ ਤੇ ਰੈਫਰ ਕਰੋ — <strong>ਕੈਸ਼ਬੈਕ</strong> ਕਮਾਓ। ਅਗਲੀ ਯਾਤਰਾ \'ਤੇ ਰਿਡੀਮ ਕਰੋ।',
      'hero.where': 'ਕਿੱਥੇ',
      'hero.whereLabel': 'ਤੁਸੀਂ ਕਿੱਥੇ ਰੁਕ ਰਹੇ ਹੋ?',
      'hero.checkIn': 'ਚੈਕ-ਇਨ',
      'hero.checkOut': 'ਚੈਕ-ਆਉਟ',
      'hero.guests': 'ਮਹਿਮਾਨ',
      'hero.search': 'ਖੋਜੋ',

      'section.trending': 'ਉੱਤਰੀ ਭਾਰਤ ਵਿੱਚ ਟ੍ਰੈਂਡਿੰਗ',
      'section.trendingSubtitle': 'ਜਿੱਥੇ ਭਾਰਤੀ ਮੁਸਾਫਰ ਹੁਣ ਜਾ ਰਹੇ ਨੇ',
      'section.seeAll': 'ਸਾਰੇ ਸਥਾਨ ਦੇਖੋ',
      'section.propertyTypes': 'ਜਾਇਦਾਦ ਕਿਸਮ ਅਨੁਸਾਰ ਬ੍ਰਾਊਜ਼ ਕਰੋ',
      'section.propertyTypesSubtitle': 'ਸ਼ਾਹੀ ਮਹਿਲਾਂ ਤੋਂ ਬਜਟ ਸਟੇ ਤੱਕ — ਸਾਡੇ ਕੋਲ ਸਭ ਹੈ',
      'section.topHotels': 'ਇਸ ਮਹੀਨੇ ਦੇ ਟੌਪ ਹੋਟਲ',
      'section.topHotelsSubtitle': 'ਮਹਿਮਾਨ ਰੇਟਿੰਗ ਅਤੇ ਤਸਦੀਕਸ਼ੁਦਾ ਬੁਕਿੰਗ ਅਨੁਸਾਰ',
      'section.editorsChoice': 'ਸੰਪਾਦਕ ਦੀ ਪਸੰਦ',
      'section.allHotels': 'ਸਾਰੇ ਉੱਤਰੀ ਭਾਰਤ ਸਟੇ',
      'section.staysIn': '{{city}} ਵਿੱਚ ਸਟੇ',
      'section.properties': '{{count}} ਜਾਇਦਾਦਾਂ',
      'section.insights': 'ਯਾਤਰਾ ਗਾਈਡ ਅਤੇ ਸ਼ਹਿਰ ਦੀਆਂ ਕਹਾਣੀਆਂ',
      'section.insightsSubtitle': 'ਪੰਜਾਬ ਤੇ ਹਰਿਆਣਾ ਦੇ ਸਥਾਨਕ ਲੋਕਾਂ ਦੁਆਰਾ ਚੁਣੇ — ਡੂੰਘਾਈ ਨਾਲ ਜਾਣ ਵਾਲੇ ਮੁਸਾਫਰਾਂ ਲਈ',
      'section.testimonials': '25,000+ ਮੁਸਾਫਰਾਂ ਦੀ ਪਸੰਦ',
      'section.testimonialsSubtitle': 'ਉੱਤਰੀ ਭਾਰਤ ਵਿੱਚ ਅਸਲੀ ਠਹਿਰਾਅ ਦੀਆਂ ਅਸਲੀ ਕਹਾਣੀਆਂ',
      'section.testimonialsTag': 'ਮੁਸਾਫਰ ਕੀ ਕਹਿੰਦੇ ਨੇ',
      'section.insightsTag': 'ਖਾਸ',
      'section.ownHotel': 'ਉੱਤਰੀ ਭਾਰਤ ਵਿੱਚ ਹੋਟਲ ਹੈ?',
      'section.ownHotelSubtitle': 'localliink.com \'ਤੇ ਆਪਣੀ ਜਾਇਦਾਦ ਮੁਫ਼ਤ ਸੂਚੀਬੱਧ ਕਰੋ। 25,000+ ਮੁਸਾਫਰਾਂ ਤੱਕ ਪਹੁੰਚੋ।',
      'section.listPropertyCta': 'ਆਪਣੀ ਜਾਇਦਾਦ ਸੂਚੀਬੱਧ ਕਰੋ →',
      'common.startingFrom': 'ਸ਼ੁਰੂ',
      'common.perNight': 'ਪ੍ਰਤੀ ਰਾਤ',
      'common.payAtHotel': 'ਹੋਟਲ \'ਤੇ ਭੁਗਤਾਨ',
      'common.readArticle': 'ਲੇਖ ਪੜ੍ਹੋ',
      'common.trending': 'ਟ੍ਰੈਂਡਿੰਗ',
      'common.featured': '⭐ ਫੀਚਰਡ',
      'common.morePhotos': '+{{count}} ਫੋਟੋਆਂ',
      'common.reviews': '{{count}} ਸਮੀਖਿਆਵਾਂ',
      'common.noHotels': 'ਤੁਹਾਡੇ ਫਿਲਟਰਾਂ ਨਾਲ ਮੇਲ ਨਹੀਂ। ਕੁਝ ਹਟਾਉਣ ਦੀ ਕੋਸ਼ਿਸ਼ ਕਰੋ।',
      'common.share': 'ਸ਼ੇਅਰ',

      'booking.title': 'ਆਪਣਾ ਠਹਿਰਾਅ ਬੁੱਕ ਕਰੋ',
      'booking.room': 'ਕਮਰਾ',
      'booking.guestsLabel': 'ਮਹਿਮਾਨ',
      'booking.guestDetails': 'ਮਹਿਮਾਨ ਵੇਰਵੇ',
      'booking.fullName': 'ਪੂਰਾ ਨਾਮ',
      'booking.email': 'ਈਮੇਲ',
      'booking.phone': 'ਫ਼ੋਨ (+91...)',
      'booking.haveGuestCode': 'ਗੈਸਟ ਕੋਡ ਹੈ?',
      'booking.apply': 'ਲਾਗੂ ਕਰੋ',
      'booking.walletDiscount': 'ਵਾਲਿਟ ਛੋਟ',
      'booking.payAtHotel': 'ਹੋਟਲ \'ਤੇ ਭੁਗਤਾਨ',
      'booking.cta': 'ਰਿਜ਼ਰਵ · ਹੋਟਲ \'ਤੇ ਭੁਗਤਾਨ',
      'booking.ctaLoading': 'ਬੁਕਿੰਗ...',
      'booking.noCharge': 'ਅਜੇ ਚਾਰਜ ਨਹੀਂ — ਪਹੁੰਚਣ \'ਤੇ ਭੁਗਤਾਨ ਕਰੋ',
      'booking.freeCancellation': 'ਹੋਟਲ \'ਤੇ ਭੁਗਤਾਨ · ਮੁਫ਼ਤ ਰੱਦ',
      'booking.about': 'ਇਸ ਠਹਿਰਾਅ ਬਾਰੇ',
      'booking.amenities': 'ਸਹੂਲਤਾਂ',
      'booking.chooseRoom': 'ਆਪਣਾ ਕਮਰਾ ਚੁਣੋ',
      'booking.aroundProperty': 'ਆਸ-ਪਾਸ',
      'booking.reviews': 'ਮਹਿਮਾਨ ਸਮੀਖਿਆਵਾਂ ({{count}})',
      'booking.filterReviews': 'ਸਮੀਖਿਆਵਾਂ ਫਿਲਟਰ ਕਰੋ',
      'booking.hideFilters': 'ਫਿਲਟਰ ਲੁਕਾਓ',
      'booking.allRatings': 'ਸਾਰੀਆਂ ਰੇਟਿੰਗਾਂ',
      'booking.replyFrom': '{{hotel}} ਦਾ ਜਵਾਬ',
      'booking.upToGuests': 'ਵੱਧ ਤੋਂ ਵੱਧ {{n}} ਮਹਿਮਾਨ',
      'booking.bookingId': 'ਬੁਕਿੰਗ ID',
      'booking.checkIn': 'ਚੈਕ-ਇਨ',
      'booking.checkOut': 'ਚੈਕ-ਆਉਟ',
      'booking.payment': 'ਭੁਗਤਾਨ',
      'booking.downloadVoucher': 'ਵਾਊਚਰ ਡਾਊਨਲੋਡ',
      'booking.rateHotel': 'ਹੋਟਲ ਨੂੰ ਰੇਟ ਕਰੋ',
      'booking.youRated': 'ਤੁਸੀਂ ਇਸ ਹੋਟਲ ਨੂੰ ਰੇਟ ਕੀਤਾ',
      'booking.cancelBooking': 'ਬੁਕਿੰਗ ਰੱਦ ਕਰੋ',

      'amenity.wifi': 'ਮੁਫ਼ਤ ਵਾਈਫਾਈ',
      'amenity.breakfast': 'ਮੁਫ਼ਤ ਨਾਸ਼ਤਾ',
      'amenity.parking': 'ਮੁਫ਼ਤ ਪਾਰਕਿੰਗ',
      'amenity.pool': 'ਪੂਲ',
      'amenity.gym': 'ਜਿਮ',
      'amenity.spa': 'ਸਪਾ',

      // Auth
      'auth.welcomeBack': 'ਮੁੜ ਸੁਆਗਤ ਹੈ',
      'auth.signInSubtitle': 'ਆਪਣੀ ਯਾਤਰਾ ਜਾਰੀ ਰੱਖਣ ਲਈ ਸਾਈਨ ਇਨ ਕਰੋ',
      'auth.emailOrPhone': 'ਈਮੇਲ ਜਾਂ ਫ਼ੋਨ',
      'auth.password': 'ਪਾਸਵਰਡ',
      'auth.signIn': 'ਸਾਈਨ ਇਨ',
      'auth.noAccount': 'ਖਾਤਾ ਨਹੀਂ ਹੈ?',
      'auth.createAccount': 'ਖਾਤਾ ਬਣਾਓ',
      'auth.signUp': 'ਸਾਈਨ ਅੱਪ',
      'auth.fullName': 'ਪੂਰਾ ਨਾਮ',
      'auth.email': 'ਈਮੇਲ',
      'auth.phone': 'ਫ਼ੋਨ',
      'auth.iAmA': 'ਮੈਂ ਹਾਂ',
      'auth.roleGuest': 'ਮਹਿਮਾਨ',
      'auth.roleHotel': 'ਹੋਟਲ ਮਾਲਕ',
      'auth.alreadyHaveAccount': 'ਪਹਿਲਾਂ ਤੋਂ ਖਾਤਾ ਹੈ?',
      'auth.sendOtp': 'OTP ਭੇਜੋ',
      'auth.verifyOtp': 'OTP ਤਸਦੀਕ ਕਰੋ',
      'auth.signingIn': 'ਸਾਈਨ ਇਨ ਹੋ ਰਿਹਾ ਹੈ...',
      'auth.creating': 'ਬਣਾਇਆ ਜਾ ਰਿਹਾ ਹੈ...',

      // My Bookings
      'mybookings.title': 'ਮੇਰੀਆਂ ਯਾਤਰਾਵਾਂ',
      'mybookings.subtitle': 'ਤੁਹਾਡੀਆਂ ਸਾਰੀਆਂ ਬੁਕਿੰਗਾਂ ਇੱਕ ਜਗ੍ਹਾ',
      'mybookings.empty': 'ਅਜੇ ਕੋਈ ਬੁਕਿੰਗ ਨਹੀਂ — ਖੋਜੋ!',
      'mybookings.exploreCta': 'ਹੋਟਲ ਖੋਜੋ',
      'mybookings.status.pending': 'ਬਕਾਇਆ',
      'mybookings.status.confirmed': 'ਪੁਸ਼ਟੀ',
      'mybookings.status.checked_in': 'ਚੈੱਕ-ਇਨ',
      'mybookings.status.checked_out': 'ਚੈੱਕ-ਆਉਟ',
      'mybookings.status.cancelled': 'ਰੱਦ',

      // Profile
      'profile.title': 'ਮੇਰੀ ਪ੍ਰੋਫ਼ਾਈਲ',
      'profile.guestCode': 'ਮੇਰਾ ਗੈਸਟ ਕੋਡ',
      'profile.guestCodeHint': '5% ਕੈਸ਼ਬੈਕ ਪਾਉਣ ਲਈ ਚੈੱਕ-ਆਉਟ ਵੇਲੇ ਇਹ ਕੋਡ ਸਾਂਝਾ ਕਰੋ',
      'profile.walletBalance': 'ਵਾਲਿਟ ਬੈਲੈਂਸ',
      'profile.walletExpiry': '30 ਦਿਨਾਂ ਵਿੱਚ ਖ਼ਤਮ',
      'profile.recentActivity': 'ਹਾਲੀਆ ਵਾਲਿਟ ਗਤੀਵਿਧੀ',
      'profile.noActivity': 'ਅਜੇ ਕੋਈ ਵਾਲਿਟ ਗਤੀਵਿਧੀ ਨਹੀਂ',
      'profile.copyCode': 'ਕੋਡ ਕਾਪੀ ਕਰੋ',
      'profile.codeCopied': 'ਗੈਸਟ ਕੋਡ ਕਾਪੀ ਹੋਇਆ',

      // Shop
      'shop.title': 'ਲੋਕਲਸ਼ੌਪ',
      'shop.subtitle': 'ਆਪਣੇ Liink ਵਾਲਿਟ ਕ੍ਰੈਡਿਟ ਨਾਲ 100% ਭੁਗਤਾਨ ਕਰੋ। ਚੁਣੇ ਹੋਏ ਯਾਤਰਾ ਸਮਾਨ ਅਤੇ ਅਸਲੀ ਪੰਜਾਬੀ ਚੀਜ਼ਾਂ।',
      'shop.allCategories': 'ਸਾਰੇ',
      'shop.addToCart': 'ਕਾਰਟ ਵਿੱਚ ਜੋੜੋ',
      'shop.cart': 'ਕਾਰਟ',
      'shop.cartEmpty': 'ਤੁਹਾਡਾ ਕਾਰਟ ਖਾਲੀ ਹੈ',
      'shop.checkout': 'ਵਾਲਿਟ ਤੋਂ {{amount}} ਭੁਗਤਾਨ ਕਰੋ',
      'shop.orderPlaced': 'ਆਰਡਰ ਦਿੱਤਾ ਗਿਆ!',
      'shop.outOfStock': 'ਸਟਾਕ ਵਿੱਚ ਨਹੀਂ',
      'shop.inStock': '{{n}} ਸਟਾਕ ਵਿੱਚ',
      'shop.walletOnly': 'ਸਿਰਫ਼ ਵਾਲਿਟ ਚੈੱਕਆਉਟ',
      'shop.deliveryName': 'ਡਿਲੀਵਰੀ ਲਈ ਪੂਰਾ ਨਾਮ',
      'shop.deliveryPhone': 'ਫ਼ੋਨ',
      'shop.deliveryAddress': 'ਪਤਾ',

      // Partner
      'partner.heroBadge': 'ਉੱਤਰੀ ਭਾਰਤ ਦੇ 32+ ਹੋਟਲਾਂ ਵਿੱਚ ਸ਼ਾਮਲ ਹੋਵੋ',
      'partner.heroTitle': 'ਆਪਣੀ ਜਾਇਦਾਦ ਇੱਥੇ ਸੂਚੀਬੱਧ ਕਰੋ',
      'partner.heroSubtitle': 'ਪੰਜਾਬ, ਹਰਿਆਣਾ ਅਤੇ ਚੰਡੀਗੜ੍ਹ ਵਿੱਚ ਲੱਖਾਂ ਮੁਸਾਫਰਾਂ ਤੱਕ ਪਹੁੰਚੋ। ਸੂਚੀਬੱਧ ਕਰਨਾ ਮੁਫ਼ਤ। ਮਹਿਮਾਨ ਦੇ ਚੈੱਕ-ਇਨ \'ਤੇ ਹੀ ਭੁਗਤਾਨ।',
      'partner.startListing': 'ਸੂਚੀਕਰਨ ਸ਼ੁਰੂ ਕਰੋ — ਮੁਫ਼ਤ ਹੈ',
      'partner.howItWorks': 'ਇਹ ਕਿਵੇਂ ਕੰਮ ਕਰਦਾ ਹੈ',
      'partner.formTitle': '60 ਸਕਿੰਟਾਂ ਵਿੱਚ ਸ਼ੁਰੂ ਕਰੋ',
      'partner.formSubtitle': 'ਕੋਈ ਭੁਗਤਾਨ ਨਹੀਂ। ਕੋਈ ਲੰਬਾ ਫਾਰਮ ਨਹੀਂ। ਬਸ ਇੱਕ ਛੋਟੀ ਜਾਣ-ਪਛਾਣ।',
      'partner.propertyName': 'ਜਾਇਦਾਦ ਦਾ ਨਾਮ',
      'partner.city': 'ਸ਼ਹਿਰ',
      'partner.email': 'ਈਮੇਲ',
      'partner.phoneOptional': 'ਫ਼ੋਨ (ਵਿਕਲਪਿਕ)',
      'partner.continue': 'ਜਾਰੀ ਰੱਖੋ',
      'partner.faqs': 'ਅਕਸਰ ਪੁੱਛੇ ਜਾਣ ਵਾਲੇ ਸਵਾਲ',

      'lang.label': 'ਭਾਸ਼ਾ',
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'hi', 'pa'],
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'localliink_lang',
    },
  });

export default i18n;
